import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { TaxDeterminationStore } from '../service/tax-determination.store';
import { TaxResponse } from '../models/TaxResponse';

@Injectable()
export class TaxDeterminationResolver implements Resolve<any> {
  constructor(private taxDeterminationStore: TaxDeterminationStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<TaxResponse>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_TAX_RATE'));
    }

    if (eventPartyId) {
      return this.taxDeterminationStore.loadTaxRatesByParty(id, eventPartyId);
    } else {
      return this.taxDeterminationStore.loadTaxRates(id);
    }

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/tax-determination.resolver.ts